// extracted by mini-css-extract-plugin
module.exports = {"btn":"paAA0dndrptc6W6Id-6nj"};